import { render } from "./AdminAuth.vue?vue&type=template&id=ae05ed74&scoped=true"
import script from "./AdminAuth.vue?vue&type=script&lang=js"
export * from "./AdminAuth.vue?vue&type=script&lang=js"

import "./AdminAuth.vue?vue&type=style&index=0&id=ae05ed74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae05ed74"]])

export default __exports__